import { render, staticRenderFns } from "./updateRGE.vue?vue&type=template&id=7cd5186d&scoped=true"
import script from "./updateRGE.vue?vue&type=script&lang=js"
export * from "./updateRGE.vue?vue&type=script&lang=js"
import style0 from "./updateRGE.vue?vue&type=style&index=0&id=7cd5186d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd5186d",
  null
  
)

export default component.exports